import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-side-menu-item',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './side-menu-item.component.html',
  styleUrls: ['./side-menu-item.component.css'],
})
export class SideMenuItem {
  active = input<boolean>(false);
  icon = input.required<string>();
  collapsed = input<boolean>(false);
  showChevron = input<boolean>(false);
}
